/*
|--------------------------------------------------------------------------
| Analytics: AAM - Alliance for Audited Media
|--------------------------------------------------------------------------
*/

/**
 * Alliance for Audited Media
 */
__gh__webApp.analytics.auditedMedia = {
	"init": function(){
		if (this.isDisabled()) { return; }
		this.loadLibrary();
	},

	"loadLibrary": function(){
		var commonJS 	= __gh__webApp.common,
			id			= commonJS.getObjectProperty(__gh__coreData["3rdParty"],"analytics.auditedMedia.id");
        ;(function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalAamNamespace=p.GlobalAamNamespace||[];
        p.GlobalAamNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments)
        };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;
        n.src=w;g.parentNode.insertBefore(n,g)}}(window,document,"script","//aamcftag.aamsitecertifier.com/aam.js","aamsitecertifier"));

        window.aamsitecertifier('newTracker', 'cf', 'aamcf.aamsitecertifier.com', {
            idWeb: id
        });

        window.aamsitecertifier('trackPageView');
        console.log("AAM Pageview sent.")
	},

	"trackGallery":function(){
		var thisObject = __gh__webApp.analytics.auditedMedia;
		if (thisObject.isDisabled() || typeof aamsitecertifier == 'undefined') { return; }

		aamsitecertifier('trackVirtualPageView');
        console.log("AAM Gallery view sent.")
	},
	
	"isDisabled":function(){
		var commonJS 	= __gh__webApp.common;
		return (!commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"analytics.auditedMedia.id")) ? true : false;
	}

};
